 
import { useCallback } from 'react';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { toIntent, useConnectWithCatalogItemAuthor } from 'src/features/catalogItem/connect';
import { mapCatalogItemToClientSelection, useAuthInterceptor } from 'src/features/auth';
import { useIntentionService } from 'src/shared/intent';
import { useCanInvite } from './useCanInvite';

export const useInviteSpecialist = (catalogItem?: CatalogItemViewModel) => {
  const connect = useConnectWithCatalogItemAuthor();
  const canInvite = useCanInvite(catalogItem);
  const withAuth = useAuthInterceptor();
  const intentionService = useIntentionService();

  return useCallback(() => {
    if (!catalogItem || !canInvite) {
      return Promise.reject(new Error('Can not invite'));
    }
    intentionService.remember(toIntent(catalogItem.id));
    return withAuth(
      (catalogItemId: number) => connect(catalogItemId),
      mapCatalogItemToClientSelection(catalogItem),
    )(catalogItem.id).then((r) => {
      intentionService.clear();
      return r;
    });
  }, [catalogItem, canInvite, intentionService, withAuth, connect]);
};
